import { FC } from 'react';
import { useIntl } from 'react-intl';
import { Select } from '@components/common/Select/Select';
import { ISelectOption } from '@components/common/Select/types';
import { IProductSelectOption } from '@pages/CalculatorPage/types';
import { FormattedCalculatorResult } from '../types';
import { ResultsSectionQuestions } from './questions';
import { ResultsSectionProps, ResultsSortingTypesEnum } from './types';
import { ResultItem } from '@pages/CalculatorPage/ResultsPage/ResultItem/ResultItem';
import { SelectedResultItem } from '@pages/CalculatorPage/ResultsPage/SelectedResultItem/SelectedResultItem';
export const ResultsSection: FC<ResultsSectionProps> = ({
  bestProduct,
  productOptions,
  financeDetails,
  setSortBy,
  sortBy,
}) => {
  const intl = useIntl();
  const { sort } = ResultsSectionQuestions(intl);

  const getSortingFunction = (sortBy: string) => {
    switch (sortBy) {
      case ResultsSortingTypesEnum.initialMonthlyRepaymentsAsc:
        return (a: FormattedCalculatorResult, b: FormattedCalculatorResult) => a.repayments - b.repayments;
      case ResultsSortingTypesEnum.initialRateAsc:
        return (a: FormattedCalculatorResult, b: FormattedCalculatorResult) => a.initialRate - b.initialRate;
      case ResultsSortingTypesEnum.initialTermAsc:
        return (a: FormattedCalculatorResult, b: FormattedCalculatorResult) => a.term - b.term;
      case ResultsSortingTypesEnum.maxFinancingDesc:
        return (a: FormattedCalculatorResult, b: FormattedCalculatorResult) => b.maxFinancing - a.maxFinancing;
      default:
        return () => 0;
    }
  };

  const sortingFunction = getSortingFunction(sortBy);

  return (
    <div className={'xs:my-8 md:my-10'}>
      {bestProduct && <SelectedResultItem resultItem={bestProduct} financeDetails={financeDetails} />}
      <div className={'ml-auto flex w-full max-w-xl items-center gap-4'}>
        {productOptions.length ? (
          <>
            <p className={'text-main shrink-0 whitespace-nowrap font-black'}>Sort by</p>
            <Select
              disableClearable
              className={'min-w-0 flex-1'}
              options={sort.options}
              value={sortBy}
              placeholder={intl.formatMessage({ id: 'placeholders.select' })}
              onChange={(_event: React.ChangeEvent<HTMLSelectElement>, option: ISelectOption | null) =>
                option && setSortBy((option as IProductSelectOption).value as string)
              }
            />
          </>
        ) : (
          ''
        )}
      </div>

      {productOptions.sort(sortingFunction).map((result, index) => (
        <ResultItem key={index} resultItem={result} />
      ))}
    </div>
  );
};
